import {Page} from '../src/common/constant/page';
import {IKwPage} from '../src/common/type';
import {redirectTo} from '../src/common/util/PageRouter';
import {TAB_PAGE_ITEMS} from '../src/home/common/common';
import HomeV4 from '../src/home/common/container/HomeV4';
import {actions} from '../src/home/common/state/action';
import {actions as homeActions} from '../src/home/common/state/action';
import {HomeTabPage, RAW_TAB_TO_TAB_KEY} from '../src/home/common/type';

interface IProps {
  initialTabPage: HomeTabPage;
}

interface IQuery {
  home: string[];
  tab?: string;
}

const HomeStaticPage: IKwPage<IProps, IQuery> = ({initialTabPage}) => {
  return <HomeV4 currentTabPage={initialTabPage} />;
};

HomeStaticPage.initialPageProps = {
  pageBgClassName: 'bg-background',
  page: Page.Home,
  getPageTitle: i18next => i18next.t('common_service_name'),
};

HomeStaticPage.getInitialProps = ({query, res, store}) => {
  let page: HomeTabPage | null = null;

  if (
    query.home === undefined ||
    (query.home.length === 1 && query.home[0] === 'main')
  ) {
    page = HomeTabPage.Main;
  } else if (query.home.length === 1) {
    const queryPage = query.home[0] as HomeTabPage;
    if (TAB_PAGE_ITEMS.find(item => item.tabPage === queryPage)) {
      page = queryPage;
    }
  }

  if (page === null) {
    redirectTo({pageInfo: '/', res});
  }

  const initialTabPage = page ?? HomeTabPage.Main;
  const initialSecondTab =
    (query.tab && RAW_TAB_TO_TAB_KEY[query.tab]) || query.tab;

  if (!store.getState().home.isInitialized) {
    store.dispatch(
      actions.fetchInitializeHome(initialTabPage, initialSecondTab)
    );
  } else {
    store.dispatch(
      homeActions.changeSecondTabSelected({
        tabPage: initialTabPage,
        selected: initialSecondTab,
        isTabClick: false,
      })
    );
  }
  return {initialTabPage};
};

export default HomeStaticPage;
